export default __webpack_public_path__ + "7456c208fab590b5de30fc8a19cb5d1a.png";